/**
 * banner-carousel
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_banner-carousel.css';
import './_banner-carousel.twig';

// Media gallery uses slick slider for the desktop and mobile displays.
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

export const name = 'banner-carousel';

export const defaults = {
  dummyClass: 'js-banner-carousel-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { bannerCarousel = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const bannerCarousels = $('.banner-carousel', $context);
  // Bail if component does not exist
  if (!bannerCarousels.length) {
    return;
  }
  const $bannerCarousel = $(bannerCarousels);

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...bannerCarousel,
  };
  // An example of what could be done with this component
  $bannerCarousel.addClass(settings.dummyClass);

  // Adds slick slider functionality.
  $bannerCarousel.each(function initializeSlickSlider() {
    const time = $(this).data('slide-time');
    $('.banner-carousel__items', this).slick({
      appendDots: $('.banner-carousel__actions', this),
      autoplay: true,
      dots: true,
      infinite: true,
      autoplaySpeed: time,
    });
  });
}

export default enable;
